import styled from 'styled-components';
import {BorderRadius} from '@theme/lib';

export const StyledImageComparison = styled('div')`
  ${props => BorderRadius(props.theme.config.imageBorderRadius.mobile)};
  img {
    min-height: 200px;
    height: 100%;
  }
`;
